// extracted by mini-css-extract-plugin
export default {"loadingContainerCenter":"styles_loadingContainerCenter__N1h9p","overlay":"styles_overlay__hasye"};